import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";

const CONTENT = {
  impressum: {
    title: "Impressum",
    sections: [
      ["Angaben gemäß § 5 TMG", "Dipl.-Volksw. Frank Saier\nFachkundige Stelle & Gründungsberatung\nBahnhofstr. 52\n79199 Kirchzarten\nDeutschland"],
      ["Kontakt", "Telefon: 07661 62209\nE-Mail: frank.saier@outlook.de\nWeb: www.gruendungszuschuss48h.com"],
      ["Umsatzsteuer-ID", "Umsatzsteuer-Identifikationsnummer gemäß § 27 a UStG: DE262457867"],
      ["Verantwortlich für den Inhalt", "Dipl.-Volksw. Frank Saier (Anschrift wie oben)"],
    ],
  },
  datenschutz: {
    title: "Datenschutzerklärung",
    sections: [
      ["1. Verantwortlicher", "Verantwortlich für die Datenverarbeitung auf dieser Website ist Frank Saier, www.gruendungszuschuss48h.com (Kontaktdaten siehe Impressum)."],
      ["2. Erhobene Daten", "Wir verarbeiten die von Ihnen im Fragebogen angegebenen Daten (Name, Kontaktdaten, Angaben zum Gründungsvorhaben) sowie hochgeladene Dokumente ausschließlich zur Erstellung Ihrer fachkundigen Stellungnahme."],
      ["3. Zweck & Rechtsgrundlage", "Die Verarbeitung erfolgt zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO). Zahlungsdaten werden über unseren Zahlungsdienstleister Stripe verarbeitet."],
      ["4. Speicherdauer", "Ihre Daten werden nur so lange gespeichert, wie es für die Leistungserbringung und gesetzliche Aufbewahrungsfristen erforderlich ist."],
      ["5. Ihre Rechte", "Sie haben das Recht auf Auskunft, Berichtigung, Löschung, Einschränkung der Verarbeitung, Datenübertragbarkeit und Widerspruch. Wenden Sie sich hierzu an die im Impressum genannte Adresse."],
      ["6. Cookies", "Wir setzen ausschließlich technisch notwendige Cookies für Anmeldung und Sitzungsverwaltung ein."],
      ["Hinweis", "Dies ist eine Platzhalter-Datenschutzerklärung. Bitte lassen Sie diese vor dem Livegang rechtlich prüfen."],
    ],
  },
  agb: {
    title: "Allgemeine Geschäftsbedingungen (AGB)",
    sections: [
      ["§ 1 Geltungsbereich", "Diese AGB gelten für alle über www.gruendungszuschuss48h.com abgeschlossenen Verträge über die Erstellung fachkundiger Stellungnahmen und zugehöriger Beratungsleistungen."],
      ["§ 2 Leistungen", "Wir erstellen fachkundige Stellungnahmen zur Tragfähigkeit von Existenzgründungen für den Gründungszuschuss. Der Express-Service sichert die Bearbeitung innerhalb von 48 Stunden nach vollständigem Eingang aller erforderlichen Unterlagen zu."],
      ["§ 3 Preise & Zahlung", "Es gelten die zum Zeitpunkt der Bestellung angegebenen Preise zzgl. der gesetzlichen Umsatzsteuer in Höhe von derzeit 19%. Die Zahlung erfolgt online im Voraus über Stripe."],
      ["§ 4 Mitwirkungspflichten", "Der Kunde stellt alle für die Bewertung erforderlichen Unterlagen vollständig und wahrheitsgemäß bereit. Die 48-Stunden-Frist beginnt erst mit vollständigem Eingang."],
      ["§ 5 Widerruf", "Verbraucher haben ein gesetzliches Widerrufsrecht. Mit ausdrücklicher Zustimmung zur sofortigen Leistungserbringung kann das Widerrufsrecht vorzeitig erlöschen."],
      ["§ 6 Haftung", "Wir haften nach den gesetzlichen Bestimmungen. Eine Gewähr für die Bewilligung des Gründungszuschusses durch die Agentur für Arbeit kann nicht übernommen werden."],
      ["Hinweis", "Dies sind Platzhalter-AGB. Bitte vor dem Livegang rechtlich prüfen lassen."],
    ],
  },
};

export default function Legal({ type }) {
  const data = CONTENT[type];
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
        <Link to="/" className="text-sm text-emerald-600 hover:underline" data-testid="legal-back">← Zurück zur Startseite</Link>
        <h1 className="mt-4 text-3xl sm:text-4xl font-bold" data-testid="legal-title">{data.title}</h1>
        <div className="mt-8 space-y-8">
          {data.sections.map(([h, body], i) => (
            <section key={i}>
              <h2 className="text-lg font-semibold text-[#0A192F]">{h}</h2>
              <p className="mt-2 text-muted-foreground whitespace-pre-line leading-relaxed">{body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
